module.exports = __webpack_public_path__ + "img/icon_black_bell.36127316.svg";